import { Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import {
  useGetGroupLinkOptionsQuery,
  useGetGroupLinkedItemsQuery,
  useLinkGroupEntityMutation,
  useUnlinkGroupEntityMutation,
} from "../../../Redux/service/Groups/GroupsLinkApi";
import trans from "../../../utils";
import { toast } from "react-toastify";

export default function GroupEntityMultiInput({
  label,
  styling,
  groupId,
  entityType,
}) {
  const [selectedValues, setSelectedValues] = useState([]);

  const { data: optionsData, isLoading: optionsLoading } =
    useGetGroupLinkOptionsQuery(
      { entityType },
      { refetchOnMountOrArgChange: true },
    );

  const { data: linkedData } = useGetGroupLinkedItemsQuery(
    { groupId, entityType },
    { skip: !groupId, refetchOnMountOrArgChange: true },
  );

  const [linkEntity] = useLinkGroupEntityMutation();
  const [unlinkEntity] = useUnlinkGroupEntityMutation();

  useEffect(() => {
    if (linkedData?.data) {
      setSelectedValues(linkedData.data.map((item) => item.id));
    }
  }, [linkedData]);

  const options = optionsData?.options || [];

  const handleSelect = async (value) => {
    setSelectedValues((prev) => [...prev, value]);
    try {
      const response = await linkEntity({
        groupId,
        entityType,
        entityId: value,
      }).unwrap();
      toast.success(response.message, {
        autoClose: 800,
      });
    } catch (error) {
      const errorMessage =
        error?.data?.message ||
        error?.message ||
        `${trans("Failed to link")} ${trans(label)}`;

      setSelectedValues((prev) => prev.filter((v) => v !== value));
      toast.error(errorMessage, {
        autoClose: 800,
      });
    }
  };

  const handleDeselect = async (value) => {
    setSelectedValues((prev) => prev.filter((v) => v !== value));
    try {
      const response = await unlinkEntity({
        groupId,
        entityType,
        entityId: value,
      }).unwrap();
      toast.success(response.message, {
        autoClose: 800,
      });
    } catch (error) {
      const errorMessage =
        error?.data?.message ||
        error?.message ||
        `${trans("Failed to unlink")} ${trans(label)}`;
      setSelectedValues((prev) => [...prev, value]);
      toast.error(errorMessage, {
        autoClose: 800,
      });
    }
  };

  return (
    <div className={styling}>
      {label && <div className="mult-input-label">{trans(label)}</div>}
      <Space style={{ width: "100%" }} direction="vertical">
        <Select
          mode="multiple"
          style={{ width: "100%", marginTop: "8px" }}
          maxTagCount="responsive"
          placeholder={trans("Please select")}
          loading={optionsLoading}
          options={options}
          value={selectedValues}
          onSelect={handleSelect}
          onDeselect={handleDeselect}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      </Space>
    </div>
  );
}
